export class RoleApproval
{
  id: number;
  users: string[];
  roles: string[];
  sendEmail: boolean;
}
